<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

@if (personAddresss != null && personId != null) {
  <div class="address_edit">
    <p-table #pt [value]="personAddresss" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="personAddressId"
      selectionMode="single" [(selection)]="personAddress" (onRowSelect)="onRowSelect($event)"
      [loading]="loading" responsiveLayout="scroll">
      <ng-template pTemplate="caption">
        <div class="btn-group" align="right">
          @if (personId != null) {
            <button mat-raised-button class="btn-upt p-button" pButton pRipple (click)="onOpenFormAdd()">Add Address +</button>
          }
          @if (personId == null) {
            <button mat-raised-button class="btn-upt p-button" color="primary" (click)="onOpenFormAdd()">Add Address +</button>
          }
        </div>
      </ng-template>
      @if (personAddresss.length > 0 && personAddresss != null) {
        <ng-template pTemplate="header">
          <tr>
            @for (col of columns; track col) {
              <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
                {{col.header}}
              </th>
            }
            <th [ngStyle]="{'width': 'auto'}"></th>
          </tr>
        </ng-template>
      }
      <ng-template pTemplate="body" let-personAddress>
        <tr [pSelectableRow]="personAddress">
          <td>{{personAddress.personAddressId}} </td>
          <td>{{getAddressType(personAddress)}}</td>
          <td>{{personAddress.adrCity}}</td>
          <td>{{personAddress.adrState}}</td>
          <td>{{personAddress.adrCountry}}</td>
          <!--<td>{{personAddress.personId}}</td>-->
          <td><span style="float:none">
            <a>
              <mat-icon style="color:blue; font-size:110%; padding-right:20px;"
              (click)="onOpenFormEdit(personAddress)">edit</mat-icon>
            </a>
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
}
@if (personAddresss == null && personId != null) {
  <div >
    <p-table #pt [value]="personAddresss" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="personAddressId"
      selectionMode="single" [(selection)]="personAddress" (onRowSelect)="onRowSelect($event)"
      [loading]="loading" responsiveLayout="scroll">
      <ng-template pTemplate="caption">
        <div align="right">
          @if (personId != null) {
            <button mat-raised-button class="p-button-text btn-upt p-button p-component" pButton pRipple (click)="onOpenFormAdd()">Add Address +</button>
          }
          @if (personId == null) {
            <button mat-raised-button color="primary btn-upt p-button p-component" (click)="onOpenFormAdd()">Add Address +</button>
          }
        </div>
      </ng-template>
    </p-table>
  </div>
}
@if (personAddresss == null && personId != null) {
  <div>
    <div align="right">
      @if (personId != null) {
        <button mat-raised-button class="p-button-text" pButton pRipple (click)="onOpenFormAdd()">Add Address +</button>
      }
      @if (personId == null) {
        <button mat-raised-button color="primary" (click)="onOpenFormAdd()">Add Address +</button>
      }
    </div>
  </div>
}
@if (personAddresss == null && personId == null) {
  <div>
    <p-table #pt [value]="personAddresss" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="personAddressId"
      selectionMode="single" [(selection)]="personAddress" (onRowSelect)="onRowSelect($event)"
      [loading]="loading" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
      currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
      sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
      [resizableColumns]="true" [autoLayout]="true" [responsive]="true">
      <ng-template pTemplate="caption">
        <div class="d-block text-end">
          <span>
            <!--clear filters-->
            <button pButton pRipple class="p-button-text"
              style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
            (click)="reloadPage()">Clear Filters</button>
            <!--add new-->
            @if (personId != null) {
              <button pButton pRipple class="p-button-text" style="padding: 0.643rem 0.75rem !important;"
              (click)="onOpenFormAdd()">New Address +</button>
            }
            @if (personId == null) {
              <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
              (click)="onOpenFormAdd()">New Address +</button>
            }
          </span>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          @for (col of columns; track col) {
            <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          }
          <th [ngStyle]="{'width': 'auto'}"></th>
        </tr>
        <tr>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'personAddressId', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'type', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'adrCity', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'adrState', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'adrCountry', 'in')"></th>
          <!--<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'personVO.personId', 'in')"></th>-->
          <th [ngStyle]="{'width': 'auto'}"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-personAddress>
        <tr [pSelectableRow]="personAddress">
          <td>{{personAddress.personAddressId}} </td>
          <td>{{getAddressType(personAddress)}}</td>
          <td>{{personAddress.adrCity}}</td>
          <td>{{personAddress.adrState}}</td>
          <td>{{personAddress.adrCountry}}</td>
          <!--<td>{{personAddress.personId}}</td>-->
          <td><span style="float:none">
            <a>
              <mat-icon style="color:blue; font-size:110%; padding-right:20px;"
              (click)="onOpenFormEdit(personAddress)">edit</mat-icon>
            </a>
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
}

@if (personAddresss != null && personId == null) {
  <div>
    <p-table #pt [value]="personAddresss" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="personAddressId"
      selectionMode="single" [(selection)]="personAddress" (onRowSelect)="onRowSelect($event)"
      [loading]="loading" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
      currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
      sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
      [resizableColumns]="true" [autoLayout]="true" [responsive]="true">
      <ng-template pTemplate="caption">
        <div class="d-block text-end">
          <span>
            <!--clear filters-->
            <button pButton pRipple class="p-button-text"
              style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
            (click)="reloadPage()">Clear Filters</button>
            <!--add new-->
            @if (personId != null) {
              <button pButton pRipple class="p-button-text" style="padding: 0.643rem 0.75rem !important;"
              (click)="onOpenFormAdd()">New Address +</button>
            }
            @if (personId == null) {
              <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
              (click)="onOpenFormAdd()">New Address +</button>
            }
          </span>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          @for (col of columns; track col) {
            <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          }
          <th [ngStyle]="{'width': 'auto'}"></th>
        </tr>
        <tr>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'personAddressId', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'type', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'adrCity', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'adrState', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'adrCountry', 'in')"></th>
          <!--<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'personVO.personId', 'in')"></th>-->
          <th [ngStyle]="{'width': 'auto'}"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-personAddress>
        <tr [pSelectableRow]="personAddress">
          <td>{{personAddress.personAddressId}} </td>
          <td>{{getAddressType(personAddress)}}</td>
          <td>{{personAddress.adrCity}}</td>
          <td>{{personAddress.adrState}}</td>
          <td>{{personAddress.adrCountry}}</td>
          <!--<td>{{personAddress.personId}}</td>-->
          <td><span style="float:none">
            <a>
              <mat-icon style="color:blue; font-size:110%; padding-right:20px;"
              (click)="onOpenFormEdit(personAddress)">edit</mat-icon>
            </a>
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
}